export const AIS_SUMMARY_TRANSACTION_PROTOCOL_ROLE_SECTION = 'app.ais3.summary.transactions.protocol.interface';
export const AIS_SUMMARY_TRANSACTION_PROTOCOL_API_PREFIX = 'ais3.summary.transactions.protocol.interface';

export const MIN_OPERATIONS = 1;
export const MAX_OPERATIONS = 1000000000000000;

export const DEFAULT_TABLE_PAGE_SIZE = 20;
